export function currency(value: string) {

    if (value && (value != '')) {
        let cleanValue = value;
        const STR_DECIMAL_SEPARATOR = ',';


        cleanValue = cleanValue.replace(/\./g, '');
        return Number(cleanValue.replace(STR_DECIMAL_SEPARATOR, '.'));
    }
    return 0;
}


export function percentage(value: string) {

  if (value && (value != '')) {
      let cleanValue = value;
      const STR_DECIMAL_SEPARATOR = ',';


      cleanValue = cleanValue.replace(/\./g, '');
      return Number(cleanValue.replace(STR_DECIMAL_SEPARATOR, '.'))/100;
  }
  return 0;
}


